class DeviceStatus {
  static getTranslationByStatus(status) {
    return DeviceStatus.states.get(status + "");
  }

  static getStatus() {
    return DeviceStatus.statesArray;
  }

  static inTransition(status) {
    return (
      status === 11 ||
      status === 21 ||
      status === 50
    );
  }
}

DeviceStatus.statusObject = {
  0: "DeviceStatus.STAGED",
  10: "DeviceStatus.OFFLINE",
  11: "DeviceStatus.ACTIVATE",
  12: "DeviceStatus.DEACTIVATE",
  20: "DeviceStatus.ONLINE",
  21: "DeviceStatus.VERIFY",
  30: "DeviceStatus.VALID",
  40: "DeviceStatus.INVALID",
  50: "DeviceStatus.REMOVING"
};

DeviceStatus.states = new Map();
DeviceStatus.statesArray = [];
for (const i in DeviceStatus.statusObject) {
  DeviceStatus.statesArray.push({
    code: i,
    translation: DeviceStatus.statusObject[i]
  });
  DeviceStatus.states.set(i + "", DeviceStatus.statusObject[i]);
}

export default DeviceStatus;
